<template src="./list.html"></template>

<script>

import JobService from 'Services/JobService';

export default {
  data() {
    return {
      topJPs: [],
      topVNs: [],
      i18n: 2,
    };
  },

  created() {
    this.list();
  },

  methods: {
    convertHTML(value) {
      if (value) {
        if (value.length < 200) {
          return `${value.replace(/(<([^>]+)>)/g, '')}`;
        }
        return `${value.replace(/(<([^>]+)>)/g, '').substring(0, 200)}...`;
      }

      return '';
    },

    list() {
      if (localStorage.getItem('lang') === 'ja') {
        this.i18n = 1;
      }

      const paramsJP = {
        address: 1,
        i18n: this.i18n,
      };
      const paramsVN = {
        address: 2,
        i18n: this.i18n,
      };
      JobService.listIntern(paramsJP)
        .then((response) => {
          this.topJPs = response.data.data;
        })
        .catch(() => {
        });
      JobService.listIntern(paramsVN)
        .then((response) => {
          this.topVNs = response.data.data;
        })
        .catch(() => {
        });
    },
  },
};
</script>
<style scoped>
pre {
     text-align: justify;
     white-space: pre-line;
};
li {
    margin-bottom: -70px;
}
</style>
